export const players = [
  {
    display: "Seraph",
    id: "seraph",
    img: "https://i.imgur.com/twkLNXE.png",
  },
  {
    display: "Brandish",
    id: "brandish",
    img: "https://i.imgur.com/3M1lmeX.png",
  },
  {
    display: "GB",
    id: "gb",
    img: "https://i.imgur.com/yRMXGUG.png",
  },
  {
    display: "MArGi",
    id: "margi",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "SirSamuel016",
    id: "sam",
    img: "https://i.imgur.com/PLn1iAN.png",
  },
  {
    display: "James Rye",
    id: "james",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "uberfayt",
    id: "uber",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "Lady pompom",
    id: "pompom",
    img: "https://i.imgur.com/kV7Dwgr.png",
  },
  {
    display: "Maryxii",
    id: "mary",
    img: "https://i.imgur.com/OIsWUCh.png",
  },
  {
    display: "Asako",
    id: "asako",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "Shad",
    id: "shad",
    img: "https://i.imgur.com/YaNAo2v.png",
  },
  {
    display: "scav",
    id: "scav",
    img: "https://i.imgur.com/M8wKIIJ.png",
  },
  {
    display: "Cinera",
    id: "cinera",
    img: "https://i.imgur.com/VRvv9at.png",
  },
  {
    display: "AwkwardMisha",
    id: "misha",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "Tatsumaki",
    id: "tatsu",
    img: "https://i.imgur.com/sXh7Y7i.png",
  },
  {
    display: "kira",
    id: "kira",
    img: "https://via.placeholder.com/64x64.png",
  },
];
